module.exports = __webpack_public_path__ + "img/right-arrow.249c8b9b.svg";